export const ENDPOINTS = {
  // company member endpoints
  GET_COMPANY_MEMBERS: "/api/wayflyer/company/:companyId/members",
  GET_COMPANY_MEMBER: "/api/wayflyer/company/:companyId/members/:userId",
  EDIT_COMPANY_MEMBER: "/api/wayflyer/company/:companyId/members/:userId/edit",
  DELETE_COMPANY_MEMBER: "/api/wayflyer/company/:companyId/members/:userId/delete",
  // company invite endpoints
  GET_COMPANY_INVITES: "/api/wayflyer/company/:companyId/invites",
  RESEND_COMPANY_INVITE: "/api/wayflyer/company/:companyId/invites/:inviteId/resend",
  DELETE_COMPANY_INVITE: "/api/wayflyer/company/:companyId/invites/:inviteId/delete",
  // funding application endpoints
  GET_APPLICATION: "/api/:customerSlug/funding/api/application/",
  CREATE_SUBSEQUENT_APPLICATION: "/api/:customerSlug/funding/api/application/subsequent-funding/create",
  SUBMIT_SUBSEQUENT_APPLICATION: "/api/:customerSlug/funding/api/application/subsequent-funding/",
  // settings endpoints
  RECONNECT_REQUIRED: "/:customerSlug/settings/api/reconnect-required",
};
